import { PatientActiveStatusEnum } from '@/types/patient';

export const CANDIDATE_STATUS_TOOLTIP = 'Missing some items in their chart.';

function normalizedPatientStatus(status?: string | null): string {
  return status?.trim().toLowerCase() ?? '';
}

export function isCandidatePatientStatus(status?: string | null): boolean {
  return normalizedPatientStatus(status) === 'candidate';
}

/** Candidate is shown as Pending. Every other unrecognized value stays Active. */
export function patientStatusLabel(status?: string | null): 'Active' | 'Inactive' | 'Paused' | 'Pending' {
  const value = normalizedPatientStatus(status);
  if (value === 'paused') return 'Paused';
  if (value === 'inactive' || value === 'closed') return 'Inactive';
  if (value === 'candidate') return 'Pending';
  return 'Active';
}

export function patientStatusEnum(status?: string | null): PatientActiveStatusEnum {
  const label = patientStatusLabel(status);
  if (label === 'Paused') return PatientActiveStatusEnum.Paused;
  if (label === 'Inactive') return PatientActiveStatusEnum.Inactive;
  if (label === 'Pending') return PatientActiveStatusEnum.Pending;
  return PatientActiveStatusEnum.Active;
}
